import { FC, ReactElement, useEffect } from 'react';

import { TrackingProvider, useTracking } from '@eneco/tracking';

type TrackViewComponentProps = {
  label: string;
  type: string;
  variant?: string;
  scope?: string;
  children: ReactElement;
  additionalInfo?: string;
};

const TrackViewComponentWithVariantInner: FC<TrackViewComponentProps> = props => {
  const { setTrackingVariant, trackViewComponent } = useTracking();
  const { variant, children } = props;

  useEffect(() => {
    setTrackingVariant(variant);
    trackViewComponent(props);
  }, [trackViewComponent, setTrackingVariant, variant, props]);
  return children;
};

export const TrackViewComponentWithScopeAndVariant: FC<TrackViewComponentProps> = props => {
  const { scope, children } = props;
  const inner = <TrackViewComponentWithVariantInner {...props}>{children}</TrackViewComponentWithVariantInner>;
  return scope ? <TrackingProvider scope={scope}>{inner}</TrackingProvider> : inner;
};
